// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  height: calc(100vh - 100px);
  background-color: white;
  flex-direction: column;
  overflow: hidden;
}

.brover-order-table {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
}
.brover-order-table__body {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  position: relative;
  border-top: 1px solid gainsboro;
}

.article-item {
  display: grid;
  grid-template-columns: 125px 125px 125px auto 90px 100px 50px;
  padding: 15px 40px;
  border-bottom: 1px solid #d5d5d5;
  -webkit-user-select: auto;
          user-select: auto;
}
.article-item:hover {
  color: #d8b399;
  background-color: #fbf5ef;
}
.article-item__column {
  margin-right: 15px;
  height: 75px;
  display: flex;
  align-items: center;
}
.article-item__column.code {
  font-size: 14px;
  font-weight: 500;
}
.article-item__column.descr {
  font-size: 12px;
  padding-right: 30px;
}
.article-item__column.amount {
  margin: 0;
  width: 100%;
}
.article-item__column.amount input, .article-item__column.amount button {
  width: 100%;
  height: 30px;
  box-sizing: border-box;
  outline: none;
}
.article-item__column.amount button {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #cecece;
  font-size: 18px;
}
.article-item__column.amount input {
  border: none;
  border-bottom: 1px solid #cecece;
  border-top: 1px solid #cecece;
  text-align: center;
  outline: none;
}
.article-item__column.price {
  font-weight: 500;
  justify-content: center;
}
.article-item__column:last-child {
  margin-right: 0;
  justify-content: center;
}
.article-item__column:last-child mat-icon {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/component/pages/order-statistics/order-statistics.component.sass"],"names":[],"mappings":"AAAC;EACC,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,kBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;AACJ;;AACA;EACE,aAAA;EACA,6DAAA;EACA,kBAAA;EACA,gCAAA;EACA,yBAAA;UAAA,iBAAA;AAEF;AAAE;EACE,cAAA;EACA,yBAAA;AAEJ;AAAE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAEJ;AAAI;EACE,eAAA;EACA,gBAAA;AAEN;AAAI;EACE,eAAA;EACA,mBAAA;AAEN;AAAI;EACE,SAAA;EACA,WAAA;AAEN;AAAM;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;AAER;AAAM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAER;AAAM;EACE,YAAA;EACA,gCAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;AAER;AAAI;EACE,gBAAA;EACA,uBAAA;AAEN;AAAI;EACE,eAAA;EACA,uBAAA;AAEN;AAAM;EACE,eAAA;AAER","sourcesContent":["\\:host\n  display: flex\n  height: calc(100vh - 100px)\n  background-color: white\n  flex-direction: column\n  overflow: hidden\n\n\n.brover-order-table\n  display: flex\n  flex-direction: column\n  flex: 1\n  position: relative\n\n  &__body\n    display: flex\n    flex-direction: column\n    flex: 1\n    overflow: auto\n    position: relative\n    border-top: 1px solid gainsboro\n\n.article-item\n  display: grid\n  grid-template-columns: 125px 125px 125px auto 90px 100px 50px\n  padding: 15px 40px\n  border-bottom: 1px solid #d5d5d5\n  user-select: auto\n\n  &:hover\n    color: #d8b399\n    background-color: #fbf5ef\n\n  &__column\n    margin-right: 15px\n    height: 75px\n    display: flex\n    align-items: center\n\n    &.code\n      font-size: 14px\n      font-weight: 500\n\n    &.descr\n      font-size: 12px\n      padding-right: 30px\n\n    &.amount\n      margin: 0\n      width: 100%\n\n      input, button\n        width: 100%\n        height: 30px\n        box-sizing: border-box\n        outline: none\n\n      button\n        width: 40px\n        display: flex\n        justify-content: center\n        align-items: center\n        border: 1px solid #cecece\n        font-size: 18px\n\n      input\n        border: none\n        border-bottom: 1px solid #cecece\n        border-top: 1px solid #cecece\n        text-align: center\n        outline: none\n\n    &.price\n      font-weight: 500\n      justify-content: center\n\n    &:last-child\n      margin-right: 0\n      justify-content: center\n\n      mat-icon\n        cursor: pointer\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
